package system

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.klock.*
import com.soywiz.korge.view.*
import com.soywiz.korim.bitmap.*
import component.*
import component.SpriteAnimationComponent.Companion.NO_ANIMATION

class SpriteAnimationSystem(
    private val animations: Map<String, SpriteAnimation> = emptyMap()
) : IteratingSystem(family { all(SpriteAnimationComponent) }) {

    override fun onTickEntity(entity: Entity) {
        val animationComponent = entity[SpriteAnimationComponent]

        if (animationComponent.nextAnimation != NO_ANIMATION) {
            val animKey = if (animationComponent.animationPrefix.isEmpty()) {
                animationComponent.nextAnimation
            } else {
                "${animationComponent.animationPrefix}-${animationComponent.nextAnimation}"
            }
            val animation = animations[animKey]
            when (animationComponent.animationType) {
                AnimationType.STANDARD -> {
                    if (animationComponent.spriteDisplayTime != TimeSpan.NIL) {
                        animationComponent.sprite.playAnimation(
                            animation,
                            spriteDisplayTime = animationComponent.spriteDisplayTime
                        )
                    } else {
                        animationComponent.sprite.playAnimation(animation)
                    }
                }

                AnimationType.DURATION -> {
//                    animationComponent.sprite.playAnimationForDuration()
                }

                AnimationType.LOOPED -> {
                    if (animationComponent.spriteDisplayTime != TimeSpan.NIL) {
                        animationComponent.sprite.playAnimationLooped(
                            animation,
                            spriteDisplayTime = animationComponent.spriteDisplayTime
                        )
                    } else {
                        animationComponent.sprite.playAnimationLooped(animation)
                    }
                }

                else -> {

                }
            }

            animationComponent.apply {

                nextAnimation = NO_ANIMATION
            }
        }
    }
}
